export function FavoriteSettingsIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2659_12422)">
        <path
          d="M20.0001 36.216C11.0523 36.216 3.78271 28.9378 3.78271 19.9986C3.78271 11.0595 11.0523 3.78125 20.0001 3.78125C28.9479 3.78125 36.2175 11.0595 36.2175 19.9986C36.2175 28.9378 28.9392 36.216 20.0001 36.216Z"
          fill="url(#paint0_linear_2659_12422)"
        />
        <path
          d="M19.9999 32.7132C27.026 32.7132 32.7129 27.0175 32.7129 20.0002C32.7129 12.9828 27.0173 7.28711 19.9999 7.28711C12.9825 7.28711 7.28687 12.9828 7.28687 20.0002C7.28687 27.0175 12.9825 32.7132 19.9999 32.7132Z"
          fill="url(#paint1_linear_2659_12422)"
        />
        <path
          opacity="0.5"
          d="M15.4737 13.0654C17.085 13.0654 18.5479 13.4099 19.3536 14.5C19.5868 14.8052 20.0002 15.4314 20.0002 15.4314C20.0002 15.4314 20.456 14.7834 20.6893 14.5C21.5161 13.3881 22.9578 13.0218 24.4631 13C26.9436 13 28.979 14.8968 29.0002 17.295C29.0214 21.9825 24.0179 25.885 21.4949 27.5638C20.6256 28.1307 19.5232 28.1525 18.6327 27.5856C16.0886 25.9504 11.0214 22.1133 11.0002 17.4258C11.0002 15.0276 12.972 13.0654 15.4737 13.0436V13.0654Z"
          fill="url(#paint2_linear_2659_12422)"
        />
        <path
          d="M16.4796 15.048C17.7329 15.048 18.8707 15.6555 19.4973 16.4549C19.6787 16.6788 19.992 17.1424 19.992 17.1424C19.992 17.1424 20.3548 16.6628 20.5361 16.4549C21.1792 15.6395 22.3006 15.016 23.4713 15C25.4007 15 26.9837 16.391 27.0002 18.1497C27.0167 21.5871 23.1251 24.449 21.1628 25.6801C20.4867 26.0958 19.6292 26.1118 18.9366 25.6961C16.9578 24.497 13.0167 21.6831 13.0002 18.2456C13.0002 16.4869 14.5338 15.048 16.4796 15.032V15.048Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2659_12422"
          x1="16.5392"
          y1="44.9204"
          x2="22.6784"
          y2="0.694294"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00E700" />
          <stop offset="0.52" stopColor="#00FF00" stopOpacity="0.89" />
          <stop offset="0.62" stopColor="#19FF00" stopOpacity="0.91" />
          <stop offset="0.82" stopColor="#59FF00" stopOpacity="0.95" />
          <stop offset="1" stopColor="#99FF00" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2659_12422"
          x1="19.9992"
          y1="33.0437"
          x2="19.9992"
          y2="6.95678"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00776B" />
          <stop offset="1" stopColor="#00DF00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2659_12422"
          x1="25.9802"
          y1="16.4707"
          x2="15.6326"
          y2="26.2944"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1FD00" stopOpacity="0.8" />
          <stop offset="1" stopColor="#DEFD92" stopOpacity="0.5" />
        </linearGradient>
        <clipPath id="clip0_2659_12422">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
